import React from 'react'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'

export const wrapPageElement = ({ element, props }) => {
  // Bara använda react-i18next för admin-sidor
  const isAdminPage = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin')
  
  if (isAdminPage) {
    return (
      <I18nextProvider i18n={i18n}>
        {element}
      </I18nextProvider>
    )
  }
  
  // För publika sidor, returnera bara element utan extra provider
  return element
}
